export const LANG_CHANGE = 'LANG_CHANGE';
export const REQUEST_PARENT_URL = 'REQUEST_PARENT_URL';
